<div class="sub-conteudo-carrousel">
    <div class="container">
        <div class="p-grid p-m-0">
            <app-noticia-carousel style="min-width: 100%"></app-noticia-carousel>
        </div>
    </div>
</div>

<div class="container p-mt-3 p-mb-6">

    <div class="p-grid nested-grid p-mt-2 p-text-center">
        <div class="p-col-12 p-xl-6 p-p-2">
                <a [routerLink]="pathCanaisAtendimento.caminho" pTooltip="Acessar página de centrais de atendimento"
                    tooltipPosition="bottom"
                    class="p-grid p-nogutter p-ai-center h-100 p-mt-1 p-p-2 p-pt-4 bg-dark-green transition p-text-left text-color-gray text-decoration-none margim-1px">
                    <div class="p-pl-4" style="width: 80px;">
                        <img src="assets/images/icon-central-atendimento.svg" alt="Ícone de central de atendimento"
                            height="62px" />
                    </div>

                    <div class="p-col p-pl-3">
                        <div class="p-text-bold text-white">
                            <span [ngStyle]="{'backgroundColor':'var(--teal-300)'}" class="p-px-1 font-montserrat">Acesse
                                nossas</span>
                        </div>
                        <span class="font-montserrat text-white" style="font-size: 22px;">Centrais de Atendimento da
                            JFRN</span>
                    </div>
                </a>
        </div>

        <div class="p-col-12 p-xl-3 p-p-2">
            <a [routerLink]="pathAjuizamentoSemAdvogado" pTooltip="Acessar página do Acesso Fácil"
                tooltipPosition="bottom" style="background-color: #1d4175"
                class="p-grid p-nogutter p-ai-center h-100 p-mt-1 p-p-4 transition text-color-gray text-decoration-none margim-1px">
                <div class="p-col-12" [ngStyle]="{'justify-content': 'center', 'text-align':'center'}">
                    <img style="height: 45px" alt="Ícone do acesso fácil" src="/assets/images/acessofacil.png" />
                </div>
                <div class="p-col text-white p-text-center" style="font-size: 15px; padding-top: 5px;">
                    Ajuizar ação sem advogado.<br>
                    <span [ngStyle]="{backgroundColor:'var(--bluegray-200)'}"
                        class="p-px-1 text-color-black">Clique aqui</span> para saber mais.
                </div>
            </a>
          <!--<a href="https://www.jfrn.jus.br/administracao/selecoes-concursos/selecao-conciliadores" pTooltip="Acessar página do Acesso Fácil"
             tooltipPosition="bottom" style="background-color: #1d4175"
             class="p-grid p-nogutter p-ai-center h-100 p-mt-1 p-p-4 transition text-color-gray text-decoration-none margim-1px">
            <div class="p-col-12" [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'color':'white'}">
              <div class="row" style="justify-content: center">
                <img style="height: 40px; margin-right: 0.5rem;" alt="Ícone do acesso fácil" src="/assets/images/mao_dupla.svg" />
                <div>
                  <h5> Seleção de <br>Conciliadores</h5>
                </div>
              </div>

            </div>
            <div class="p-col text-white p-text-center" style="font-size: 15px; padding-top: 5px;">
              As inscrições estão abertas para Natal até o dia 05/05.<br>
              <span [ngStyle]="{backgroundColor:'var(&#45;&#45;bluegray-200)'}"
                    class="p-px-1 text-color-black">Clique aqui</span> para saber mais.
            </div>
          </a>-->
        </div>
        <div class="p-col-12 p-xl-3 p-p-2">
            <div *ngIf="aviso" class="h-100">
                <a [routerLink]="'transparencia/licitacoes/aviso-dispensa'" pTooltip="Visualizar aviso de dispensa"
                    tooltipPosition="bottom"
                    class="p-grid p-nogutter h-100 transition p-text-left text-color-gray text-decoration-none">
                    <div pTooltip="Acessar página de aviso de dispensa de licitação" tooltipPosition="bottom"
                        class="p-grid p-nogutter p-ai-center h-100 p-mt-1 p-p-4 transition p-text-left bg-orange text-color-gray text-decoration-none margim-1px">
                        <div class="p-col-12"
                            [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'margin-bottom':'5px'}">
                            <img height="45px" alt="Ícone de balão" src="/assets/images/Concurso_novo.svg" /> <span
                                style="margin-left: 10px; color: #5776b0; font-size: 18px; font-weight: bold;">JFRN</span>
                            <span
                                style="color: #5776b0; font-size: 18px; font-weight: bold; font-style: italic">Licita:</span>
                        </div>
                        <div class="p-col-12 p-text-bold"
                            [ngStyle]="{'justify-content': 'center', 'text-align':'center'}">
                            Novo aviso de dispensa de licitação disponível. Clique aqui para ter acesso aos documentos e
                            enviar sua proposta.
                        </div>
                    </div>
                </a>
            </div>
            <div *ngIf="!aviso" class="h-100">
                <!--<a pTooltip="Horário de atendimento presencial" tooltipPosition="bottom"
                    class="p-grid p-nogutter p-ai-center h-100 p-mt-1 p-p-4 transition p-text-left bg-orange text-color-gray text-decoration-none margim-1px">
                    <div class="p-col-12" [ngStyle]="{'justify-content': 'center', 'text-align':'center'}">
                        <img height="45px" alt="Ícone de relógio" src="/assets/images/clock-regular.svg" />
                    </div>
                    <div class="p-col-12 p-text-bold"
                        [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'cursor':'default'}">
                        Horário de atendimento presencial <span
                            [ngStyle]="{'font-size':'1.1rem','backgroundColor':'var(&#45;&#45;orange-300)'}"
                            class="p-px-1">8h às 14h</span>
                    </div>
                </a>-->

                <a href="http://gg.gg/pesquisa-site-jfrn" target="_blank"
                   tooltipPosition="bottom" style="background-color: #bddbf3b0;"
                   class="p-grid p-nogutter h-100 p-mt-1 transition p-text-left text-color-gray text-decoration-none">
                    <div pTooltip="Acessar página da pesquisa sobre o site" tooltipPosition="bottom"
                         class="p-grid p-nogutter p-ai-center h-100 p-mt-1 w-100 p-p-4 transition p-text-left  text-color-gray text-decoration-none margim-1px">
                        <div class="p-col-12"
                             [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'margin-bottom':'5px'}">
                            <img height="45px" alt="Ícone de balão" src="/assets/images/icone-card-pesquisa.png" />
                            <span style="color: white !important; background-color: #007275 !important; padding: 2px 8px 2px 4px; border-radius: 5px; font-size: 17px; font-weight: bold; font-style: italic">Queremos te ouvir</span>
                        </div>
                        <div class="p-col-12 p-text-bold" style="color: #007275"
                             [ngStyle]="{'justify-content': 'center', 'text-align':'center'}">
                            A JFRN quer ouvir você sobre nosso site.
                            <span style="color: white !important; background-color: #007275 !important; padding: 2px; border-radius: 5px; font-size: 15px;"
                                  class="p-px-1 text-color-black">Clique aqui</span> e responda nossa pesquisa.
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <div class="p-grid p-mt-2 p-text-center">
        <app-caixa-navegacao-azul class="p-col-12 p-md-6 p-lg-3 p-p-2" nomeCaixa={{pathBuscaProcessual.nomeExibicao}}
            iconeCaixa="search" linkCaixa={{pathBuscaProcessual.caminho}}
            titleCaixa="Acessar página de Busca Processual"></app-caixa-navegacao-azul>
        <app-caixa-navegacao-azul class="p-col-12 p-md-6 p-lg-3 p-p-2" nomeCaixa="Transparência" iconeCaixa="eye"
            linkCaixa={{pathTransparencia.caminho}}
            titleCaixa="Acessar página de Transparência"></app-caixa-navegacao-azul>
        <app-caixa-navegacao-azul class="p-col-12 p-md-6 p-lg-3 p-p-2" nomeCaixa="Mais Notícias" iconeCaixa="comments"
            linkCaixa="{{pathImprensa}}" titleCaixa="Acessar página das notícias"></app-caixa-navegacao-azul>

        <div class="p-col-12 p-md-6 p-lg-3 p-p-2">
            <a href="/curadoria-quinta-juridica" pTooltip="Curadoria da Quinta Jurídica da JFRN" tooltipPosition="bottom"
               class="p-grid p-nogutter p-ai-center h-100 p-p-4 transition p-text-left text-color-gray text-decoration-none" style="background-color: #cdeff1;">
                <div class="p-col-12" [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'margin-bottom':'5px'}">
                    <img height="45px" alt="Ícone de relógio" src="/assets/images/curadoria-quinta-juridica.png" />
                    <span style=" background-color: #02cada !important; margin-left: 0.5rem;; padding: 2px 8px 2px 4px; border-radius: 5px; font-size: 17px; font-weight: bold; font-style: italic;">Quinta Jurídica</span>
                </div>
                <div class="p-col-12 p-text-bold"
                     [ngStyle]="{'justify-content': 'center', 'text-align':'center', 'font-size': '14px'}">
                    Curadoria de Eventos de Extensão Acadêmica pelo Projeto Quinta Jurídica 2026. <span
                    [ngStyle]="{'backgroundColor':'#02cada', 'font-size': '14px'}"
                    class="p-px-1">Clique aqui</span> para mais informações.
                </div>
            </a>
        </div>

    </div>


    <div class="p-grid p-mt-1 p-text-center">
        <app-blocos-brancos class="p-col-12 p-md-6 p-xl-4 p-p-2" iconeCaixa="book"
            linkCaixa="http://rpvprecatorio.trf5.jus.br/" titleCaixa="Acessar página de RPV/Precatório"
            nomeCaixa="RPV/Precatório" [abrirNovaAba]="true"></app-blocos-brancos>
        <app-blocos-brancos class="p-col-12 p-md-6 p-xl-4 p-p-2" iconeCaixa="file"
            linkCaixa="{{pathCertidaoNegativa.caminho}}" titleCaixa="Acessar página de Certidão Negativa"
            nomeCaixa="{{pathCertidaoNegativa.nomeExibicao}}"></app-blocos-brancos>
        <app-blocos-brancos class="p-col-12 p-md-12 p-xl-4 p-p-2" iconeCaixa="users"
            linkCaixa="{{pathJuizadosEspeciais.caminho}}" titleCaixa="Acessar página de Juizados Especiais Federais"
            nomeCaixa="Juizados Especiais Federais"></app-blocos-brancos>
    </div>

    <app-caixa-pje></app-caixa-pje>

    <div class="p-grid p-mt-1 p-text-center">
        <app-caixa-navegacao-azul class="p-col-12 p-md-6 p-xl-3 p-p-2" nomeCaixa="Diário Eletrônico" iconeCaixa="print"
            titleCaixa="Acessar página de Diário Eletrônico" [abrirNovaAba]="true"
            linkCaixa="https://www4.trf5.jus.br/diarioeletinternet/"></app-caixa-navegacao-azul>
        <app-caixa-navegacao-branca class="p-col-12 p-md-6 p-xl-3 p-p-2" nomeCaixa="{{pathQuintaJuridica.nomeExibicao}}"
            [exibirIcone]="false" imagemCaixa="quinta-juridica-simples.png"
            titleCaixa="Acessar página da Quinta Jurídica"
            [linkCaixa]="pathQuintaJuridicaCaminho"></app-caixa-navegacao-branca>
        <app-caixa-navegacao-branca class="p-col-12 p-md-6 p-xl-3 p-p-2" nomeCaixa="Custas Processuais"
            [exibirIcone]="true" iconeCaixa="wallet" titleCaixa="Acessar página de Custas Processuais"
            linkCaixa="custas-processuais"></app-caixa-navegacao-branca>
        <app-caixa-navegacao-azul class="p-col-12 p-md-6 p-xl-3 p-p-2" nomeCaixa="{{pathJurisdicao.nomeExibicao}}"
            iconeCaixa="map-marker" titleCaixa="Acessar página de Jurisdição"
            linkCaixa="{{pathJurisdicao.caminho}}"></app-caixa-navegacao-azul>
    </div>
    <hr>

    <div class="container">
    <div class="row" style="justify-content: center;">
    <ng-container *ngFor="let banner of banners; let i = index;">
      <div class="col-lg-3 col-md-4 col-sm-6 col-12" style="padding-right:0%; padding-left:0%;">
        <div class="card mb-1 mx-1">

          <div *ngIf="!banner.ehComissao" class="card-body" style="display: flex; justify-content: center; align-items: center; background-color:#dde2ea; display: flex;height: 140px">
            <a href="{{ banner.linkPagina }}" pTooltip="Acessar página: {{ banner.descricao }}" tooltipPosition="bottom" class="p-d-block" rel="noopener"
               style="display: flex !important;justify-content: center;">
              <img [src]="banner.linkImagem" [alt]="banner.descricao" [ngStyle]="{ maxHeight:getHeightImage(banner), maxWidth:getWidthImage(banner) }"/>
            </a>
          </div>


            <div *ngIf="banner.ehComissao" class="card-body" style="display: flex; justify-content: center; align-items: center; background-color:#dde2ea; display: flex;height: 140px">
              <a routerLink= "{{banner.linkPagina}}" pTooltip="Acessar página: {{ banner.descricao }}" tooltipPosition="bottom" class="p-d-block" rel="noopener"
                 style="display: flex !important;justify-content: center;">
                <img [src]="banner.linkImagem" [alt]="banner.descricao" [ngStyle]="{ maxHeight:getHeightImage(banner), maxWidth:getWidthImage(banner) }"/>
              </a>
            </div>

        </div>
      </div>
    </ng-container>
  </div>
</div>

    <div class="p-grid p-mt-4 p-text-center">
        <h2 class="p-col-12 titulos-secoes">NOTÍCIAS</h2>
        <app-noticia-pagina-principal class="p-col-12 p-md-4 p-p-2" *ngFor="let noticia of ultimasNoticias"
            [noticia]="noticia"></app-noticia-pagina-principal>
    </div>
</div>
